<template>
  <tr>
    <td>
      <div class="form-switch">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="receiveLeads"
          :value="true"
          :id="`contact-radio-${contact.contactID}`"
        />
      </div>
    </td>
    <td>
      <label
        class="form-check-label"
        :for="`contact-radio-${contact.contactID}`"
      >
        {{ contact.contactName }}
      </label>
    </td>
  </tr>
</template>

<script>
import SettingsService from "../../../services/SettingsService";
import TrackingService from "../../../services/TrackingService";

export default {
  name: "account.profile.contactTableRow",
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    let contact = this.contact;
    return {
      receiveLeads: contact.receiveLeads,
    };
  },
  watch: {
    receiveLeads: function (val, oldVal) {
      if (val === oldVal) {
        return;
      }

      this.saveContact();
    },
  },
  methods: {
    async saveContact() {
      TrackingService.track("updated the lead contact");

      let company = this.$auth.activeCompany;

      let contact = {
        ContactID: this.contact.contactID,
        ReceiveLeads: this.receiveLeads,
      };

      await SettingsService.saveLeadContact(company.companyId, contact);
    },
  },
};
</script>
